import type {BookingGroup} from "@/serviceWorker/workerComponents/Models/BookingGroup";
import {reactive, watchEffect} from "vue";
import type {RoomPeopleConfiguration} from "@/serviceWorker/workerComponents/Models/RoomPeopleConfiguration";
import type {AgeGroupCount} from "@/frontendClasses/AgeGroupCount";

/**
 * Wersja dodatkowego pokoju gdzie dzieci są podawane jako ilość per grupa wiekowa
 * Pokazywana w oknie ustawiania konfiguracji osób i w oknie wyboru pokoju
 */
export class ExtraRoomByAgeGroup {
    private bookingGroups: BookingGroup[];

    constructor(newRoom: RoomPeopleConfiguration, bookingGroups: BookingGroup[]) {
        this.ageGroups = reactive([]);
        this.bookingGroups = bookingGroups;
        this.updateFromSearchData(newRoom);
        watchEffect(this.onAgeGroupsUpdated.bind(this));
    }

    updateFromSearchData(room: RoomPeopleConfiguration) {
        this.adultCount = room.adultCount || 0;
        this.roomUniqueId = room.uniqueId;
        const childrenAges = room.childrenAges || [];
        this.ageGroups = reactive([]);
        for (let bookingGroup of this.bookingGroups) {
            const ageGroupData = reactive({ageGroup: bookingGroup, count: 0});
            if (bookingGroup.default == 1 && room.adultCount) {
                ageGroupData.count = room.adultCount;
            } else {
                for (let childAge of childrenAges) {
                    if (childAge >= bookingGroup.from_age && childAge <= bookingGroup.to_age) {
                        ageGroupData.count++;
                    }
                }
            }
            this.ageGroups.push(ageGroupData);
        }
        //Sortowanie od najstarszego
        this.ageGroups.sort((a, b) => b.ageGroup.from_age  - a.ageGroup.from_age);

        this.onAgeGroupsUpdated();
    }

    /**
     * Łączna ilość osób dorosłych
     */
    adultCount: number = 1;
    /**
     * Unikalny id tej grupy osób w rezerwacji grupowej - nigdy się nie powtórzy podczas jednej sesji rezerwacji
     */
    roomUniqueId: number | null = null;
    /**
     * Dane ilości osób per grupa wiekowa - posortowane od najstarszej grupy wiekowej do najmłodszej
     */
    ageGroups: AgeGroupCount[] = [];
    /**
     * Łączna ilość dzieci
     */
    childrenCount: number = 0;

    onAgeGroupsUpdated() {
        this.childrenCount = 0;
        this.adultCount = 0;
        for (let a of this.ageGroups) {
            if(a.ageGroup.default != 1) {
                this.childrenCount += a.count;
            } else {
                this.adultCount += a.count;
            }
        }
    }
}